<app-uni-page [parent]="this" pageTitle="In-Process: Integrity Audits - {{ title }}" [bodyTemplate]="bodyTemplate"
  [footerTemplate]="footerTemplate">
</app-uni-page>

<ng-template #bodyTemplate>
  <div class="content-card" style="height: 25vh">
    <div class="flex justify-between items-center mr-4 mb-3 shrink-0">
      <div class="flex items-center gap-2.5">
        <p-selectButton [options]="showModes" [(ngModel)]="showMode" optionValue="value" optionLabel="label">
        </p-selectButton>
        <button *ngIf="showMode == 'err'" pButton type="button" class="p-button-raised p-button-sm p-button-danger"
          icon="pi pi-lock" (click)="forceCloseJoHeader()">
          <span>Force Close Job Order</span>
        </button>
        <button pButton type="button" class="p-button-raised p-button-sm" icon="pi pi-filter-slash"
          (click)="clearFilters()">
          <span>Clear All Filters</span>
        </button>

        <span class="ml-4">{{ message }}</span>
      </div>
    </div>
    <app-ag-grid *ngIf="showMode == 'all'" [gridOptions]="johGridOptions"
      style="height: calc(100% - 50px)"></app-ag-grid>
    <app-ag-grid *ngIf="showMode == 'err'" [gridOptions]="johErrGridOptions"
      style="height: calc(100% - 50px)"></app-ag-grid>
    <ng-template #editJohNotesCell let-row>
      <button pButton type="button" class="p-button-text p-button-sm" [ngClass]="{ 'btn-has-data': hasJohNotes(row) }"
        (click)="editJohNotes(row)">Notes</button>
    </ng-template>
  </div>
  <div class="content-card" style="height: 30vh">
    <app-ag-grid #gridJoDetails [gridOptions]="jodGridOptions" [rowData]="joDetails"></app-ag-grid>
    <ng-template #editJodNotesCell let-row>
      <button pButton type="button" class="p-button-text p-button-sm" [ngClass]="{ 'btn-has-data': hasJodNotes(row) }"
        (click)="editJodNotes(row)">Notes</button>
    </ng-template>
  </div>

  <div class="content-card" style="height: 30vh">
    <p-tabView (onChange)="onTabChanged($event)" class="h-full w-full uni-tabview" styleclass="h-full">
      <p-tabPanel header="Purchase Order Details">
        <app-ag-grid [gridOptions]="podGridOptions" [rowData]="poDetails"></app-ag-grid>
        <ng-template #editPodNotesCell let-row>
          <button pButton type="button" class="p-button-text p-button-sm"
            [ngClass]="{ 'btn-has-data': hasPodNotes(row) }" (click)="editPodNotes(row)">Notes</button>
        </ng-template>
      </p-tabPanel>
      <p-tabPanel header="Cancelled Purchase Order Details">
        <app-ag-grid [gridOptions]="podcGridOptions" [rowData]="poDetailCancels"></app-ag-grid>
      </p-tabPanel>
      <p-tabPanel header="Item Details">
        <app-ag-grid [gridOptions]="itdGridOptions" [rowData]="itemDetails"></app-ag-grid>
      </p-tabPanel>
    </p-tabView>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>